import styled from "styled-components";
import { Slider, Tooltip } from "antd";
import { SliderSingleProps } from "antd/lib";
import { FLEX } from "styles/flex";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";

type Props = {} & SliderSingleProps;
interface CustomTooltipProps {
  value?: number;
}

const ClusterTooltip = ({ value }: CustomTooltipProps) => {
  return (
    <Tooltip
      overlayInnerStyle={{
        backgroundColor: "#2c3e50",
        padding: "4px 8px",
      }}
    >
      <TooltipContainer>
        <span className="cluster-tooltip-title">MARKER CLUSTERES</span>
        <span className="cluster-tooltip-value">
          RADIUS: <span className="value">{value}</span>
        </span>
      </TooltipContainer>
    </Tooltip>
  );
};

const ClusterControl = (props: Props): JSX.Element => {
  return (
    <Container>
      <Slider
        {...props}
        vertical
        step={5}
        tooltip={{
          placement: "left",
          formatter: (value: number | undefined) => (
            <ClusterTooltip value={value} />
          ),
        }}
      />
    </Container>
  );
};

const TooltipContainer = styled.div`
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 3px;
  line-height: normal !important;
  padding: 4px 2px;

  .cluster-tooltip-title {
    font-size: ${calcRem(14)};
    color: ${COLORS.BUTTONS1};
    font-weight: 500;
  }
  .cluster-tooltip-value {
    color: ${COLORS.WHITE};
    font-size: ${calcRem(12)};

    .value {
      font-weight: bold;
    }
  }
`;

const Container = styled.div`
  /* border: 1px solid blue; */
  height: 130px;
  display: inline-block;
  margin-inline-start: 70;

  .ant-slider {
    :hover {
      .ant-slider-track {
        background-color: ${({ theme }) =>
          theme.value === "light"
            ? theme.COLORS.BUTTONS1
            : theme.COLORS.WIDGETCOLOR}10;
      }
    }
  }

  .ant-slider-rail {
    background-color: ${({ theme }) => theme.COLORS.BORDER};
  }

  .ant-slider-track {
    background-color: ${({ theme }) =>
      theme.value === "light"
        ? theme.COLORS.BUTTONS1
        : theme.COLORS.WIDGETCOLOR};
  }

  .ant-slider-handle {
    :focus {
      ::after {
        box-shadow: 0 0 0 2.5px
          ${({ theme }) =>
            theme.value === "light"
              ? theme.COLORS.BUTTONS1
              : theme.COLORS.WIDGETCOLOR};
      }
    }
    ::after {
      box-shadow: 0 0 0 2px
        ${({ theme }) =>
          theme.value === "light"
            ? theme.COLORS.BUTTONS1
            : theme.COLORS.WIDGETCOLOR};
    }
  }
`;

export default ClusterControl;
